import { createSlice } from '@reduxjs/toolkit';
import { CYCLE_REPORT } from '../../actions/Reports/actionCycleTypes';

const cycleComparisonInitialState = {
  cycleReport: {
    cycleReportdata: [],
    dropDown: [],
    exportFileData: [],
    isLoading: false,
    errors: ''
  }
};

export const cycleReportSlice = createSlice({
  name: CYCLE_REPORT,
  initialState: cycleComparisonInitialState,
  reducers: {
    /* This action will trigger our saga middleware
       and set the loader to true and reset error message.
    */

    getCycleDropDownAction: (state) => {
      state.isLoading = true;
      state.cycleReport.errors = '';
    },

    getCycleDropDownSuccessAction: (state, action) => {
      if (action.payload) {
        state.cycleReport.dropDown = action.payload;
      }
      state.cycleReport.isLoading = false;
    },
    getCycleDropDownFailureAction: (state, action) => {
      state.cycleReport.isLoading = false;
      state.cycleReport.errors = action.payload;
    },
    getCycleReportAction: (state) => {
      state.isLoading = true;
      state.cycleReport.errors = '';
    },

    getCycleReportSuccessAction: (state, action) => {
      if (action.payload) {
        state.cycleReport.cycleReportdata = action.payload;
      }
      state.cycleReport.isLoading = false;
    },
    getCycleReportFailureAction: (state, action) => {
      state.cycleReport.isLoading = false;
      state.cycleReport.errors = action.payload;
    },
    getCycleExportFileAction: (state) => {
      state.isLoading = true;
      state.cycleReport.errors = '';
    },

    getCycleExportFileSuccessAction: (state, action) => {
      if (action.payload) {
        state.cycleReport.exportFileData = action.payload;
      }
      state.cycleReport.isLoading = false;
    },
    getCycleExportFileFailureAction: (state, action) => {
      state.cycleReport.isLoading = false;
      state.cycleReport.errors = action.payload;
    }
  }
});

/* getUserSuccessAction and getUserErrorAction will be used inside the saga
  middleware. Only getUserAction will be used in a React component.
*/

export const {
  getCycleDropDownAction,
  getCycleDropDownSuccessAction,
  getCycleDropDownFailureAction,
  getCycleReportAction,
  getCycleReportSuccessAction,
  getCycleReportFailureAction,
  getCycleExportFileAction,
  getCycleExportFileSuccessAction,
  getCycleExportFileFailureAction
} = cycleReportSlice.actions;
export default cycleReportSlice.reducer;
